document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById('custom-product-card-styles')) {
    const style = document.createElement('style');
    style.id = 'custom-product-card-styles';
    style.textContent = `
      .product-card__media::before,
      .product-card__media::after,
      .product-card__image::before,
      .product-card__image::after {
        content: none !important;
        display: none !important;
      }

      .product-card__image--secondary,
      .product-card__media img + img,
      .product-card__media picture + picture,
      .product-card__media picture + img,
      .product-card__media img + picture {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        position: absolute !important;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: -1;
      }
      
      .product-card__media,
      .product-card__image {
        transform: none !important;
        transition: none !important;
      }
      
      .product-card__image {
        display: block;
        position: relative;
        z-index: 1;
      }
    
      .product-card {
        border: 1px solid #e5e5e5;
        padding: 12px;
        max-width: 250px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        background-color: white;
        border-radius: 6px;
        box-shadow: 0 1px 3px rgb(0 0 0 / 0.05);
        font-size: 14px;
      }
      .product-card:hover {
        box-shadow: 0 4px 8px rgb(0 0 0 / 0.1);
      }
      .product-card__image {
        width: 100%;
        height: auto;
        border-radius: 6px;
        object-fit: cover;
      }
      .product-title {
        font-weight: 600;
        margin-top: 8px;
        color: #111;
        text-decoration: none;
        font-size: 15px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        min-height: 3.2em; /* Ensures space for 2 lines */
        line-height: 1.6em;
      }
      .price-list {
        margin-top: 4px;
        font-size: 14px;
        color: #111;
      }
      .price--regular {
        color: #666;
        font-weight: normal;
      }
      .price--sale {
        color: #e60023;
        font-weight: 700;
        margin-left: 6px;
      }
      .smallcaps {
        text-transform: uppercase;
        font-size: 11px;
        color: #888;
      }
      b {
        font-weight: 600;
        font-size: 13px;
        margin-top: 4px;
        display: block;
      }
    `;
    document.head.appendChild(style);
  }

  console.warn('⚠️ JS LOADED');
  
  function getProductBlocks() {
    const blocks = [];
    const elements = Array.from(document.querySelectorAll("p",));

    let currentBlock = null;

    elements.forEach((el) => {
        const text = el.textContent.trim();

        if (text === "[PRODUCTS]") {
            currentBlock = {
                container: el,
                handles: []
            };

            el.innerText = ""

            blocks.push(currentBlock);
            return;
        }

        if (text === "[ENDPRODUCTS]") {
            if (currentBlock) {
                el.remove(); // remove [ENDPRODUCTS] text
                currentBlock = null;
            }

            return;
        }

        if (currentBlock && text.length > 0) {
            currentBlock.handles.push(text);
            el.remove()
        }
    });

    if (blocks === []) {
        return null;
    }

    return blocks;
  }

  const productBlocks = getProductBlocks();

  if (productBlocks === null)
  {
    console.log("No blog products found...");
  } else {
    console.log(productBlocks);
    handles = productBlocks
    loadContent(handles)
  }

  function loadContent(data) {
    const SHOP_DOMAIN = 'energypowersports.myshopify.com';
    const STOREFRONT_TOKEN = 'afba58634481d3a010dbbec4e271109b';

    productBlocks.forEach(async (block) => {
      const handles = block.handles
      const container = block.container;
      handles.forEach(async (handle) => {
        const num_items = handles.length;
        console.log(`Fetching product data for handle: ${handle}`)

        const query = `
          query ProductByHandle($handle: String!) {
            productByHandle(handle: $handle) {
              title
              handle
              vendor
              images(first: 1) {
                edges {
                  node {
                    src
                    altText
                    width
                    height
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    sku
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        `;

        try {
          const res = await fetch(`https://${SHOP_DOMAIN}/api/2024-04/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
            },
            body: JSON.stringify({
              query,
              variables: { handle }
            })
          });

          if (!res.ok) throw new Error(`HTTP ${res.status}`);

          const { data, errors } = await res.json();

          if (errors) {
            console.error('🛑 GraphQL error:', errors);
            return;
          }

          const product = data.productByHandle;
          if (!product) {
            console.warn(`⚠️ No product found for handle: ${handle}`);
            return;
          }

          console.log('✅ Product fetched:', product);

          const variant = product.variants.edges[0]?.node;
          const image = product.images.edges[0]?.node || {};

          const isOnSale = variant.compareAtPrice && parseFloat(variant.compareAtPrice.amount) > parseFloat(variant.price.amount);
          console.log(variant.price)

          const priceHTML = isOnSale
          ? `
              <span class="price price--sale" style="color: #FFDD00; font-weight: bold; margin-left: 8px;">
              $${variant.price.amount}
              </span>  
              <span class="price price--regular" style="text-decoration: line-through; color: #999;">
              $${variant.compareAtPrice.amount}
              </span>
              `
          : `<span class="price price--regular" style="font-weight: bold;">
              $${variant.price.amount}
              </span>`;

          const productHTML = `
            <product-card class="product-card" handle="${product.handle}">
                <div>
                <a href="/products/${product.handle}" data-instant style="background: none !important;">
                    <img
                    src="${image.src || ''}"
                    alt="${image.altText || product.title}"
                    class="blog_image_link"
                    loading="lazy"
                    sizes="(max-width: 699px) 74vw, (max-width: 999px) 38vw, calc((100vw - 96px) / 3 - (24px / 3 * 2))"
                    width="${image.width || 400}"
                    height="${image.height || 500}"
                    >
                </a>
                </div>

                <div class="product-card__info empty:hidden">
                <div class="v-stack justify-items-center gap-2">
                    <div class="smallcaps">${product.vendor}</div>

                    <div class="v-stack justify-items-center gap-1">
                    <a href="/products/${product.handle}" class="product-title h6" data-instant>
                        ${product.title}
                    </a>
                    <b>SKU ${variant.sku || 'N/A'}</b>
                    <div class="product-card__price price-list">
                        ${priceHTML}
                    </div>
                    </div>
                </div>
                </div>
                <a href="/products/${product.handle}" class="button button--primary product-card__view-button" data-instant>
                View product
            </a>
            </product-card>
          `;

          const card = document.createElement("div");
          const width = 100 / num_items;
          card.style = `display: inline-block; width: ${width}%;`
          container.appendChild(card);

          card.innerHTML = productHTML;
        } catch (err) {
          console.error('❌ Failed to fetch product:', err);
        }
      });
    });
  }
});